import { useState, useEffect, useCallback } from "react";

export const useSearchDropdownState = () => {
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);

  const checkSearchDropdownState = useCallback(() => {
    const searchDropdown = document.querySelector(
      '[data-component="search-dropdown"][data-state="open"]',
    );
    const isOpen = searchDropdown !== null;
    setIsSearchDropdownOpen(isOpen);
  }, []);

  useEffect(() => {
    checkSearchDropdownState();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-state" &&
          (mutation.target as Element).hasAttribute("data-component") &&
          (mutation.target as Element).getAttribute("data-component") ===
            "search-dropdown"
        ) {
          checkSearchDropdownState();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-state"],
      subtree: true,
    });

    const handleClick = () => {
      setTimeout(checkSearchDropdownState, 10);
    };

    document.addEventListener("click", handleClick);

    return () => {
      observer.disconnect();
      document.removeEventListener("click", handleClick);
    };
  }, [checkSearchDropdownState]);

  return isSearchDropdownOpen;
};
